import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'

class Toggle extends React.Component {
  render() {
    return (
      <div
        className="toggle__container"
        onClick={this.props.onClick}
        onKeyDown={this.props.onClick}
        role="button"
        tabIndex={0}
      >
        <div className="toggle__label">{this.props.label}</div>
        <div className={'toggle ' + (this.props.on && 'on')}>
          <div className="toggle__inner" />
        </div>
      </div>
    )
  }
}

Toggle.propTypes = {
  type: PropTypes.string,
}

export default Toggle
